import {Injectable} from '@angular/core';
import {environment} from '@/environments/environment';
import {Observable} from 'rxjs';
import {User} from '@/app/core/models/user';
import { HttpClient } from "@angular/common/http";

@Injectable({
	providedIn: 'root'
})
export class UserService {

	constructor(
		private readonly http: HttpClient
	) {}

	private readonly SERVICE_URI = `${environment.backendUrl}/user/twitch`;

	public getUserProfile(): Observable<User> {
		return this.http.get<User>(`${this.SERVICE_URI}/me`);
	}

	deleteAccount(): Observable<void> {
		return this.http.delete<void>(`${this.SERVICE_URI}/me`);
	}
}
